import { useLocation, useNavigate } from "react-router-dom";
import MainContainer from "../../layout/MainContainer";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button, IconButton } from "@mui/material";

import IosSwitch from "../../components/iosSwitch";

const ViewSubscription = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { status, memberType } = location.state || {};

  const goBack = () => {
    navigate(-1);
  };
  const subscriptionData = [
    {
      id: 1,
      name: "John Doe",
      image: "/static/images/placeholder.png",
      email: "john@example.com",
      membership: "Single",
      date: "2025-07-01",
    },
    {
      id: 2,
      name: "Jane Smith",
      image: "/static/images/placeholder.png",
      email: "jane@example.com",
      membership: "Duo",
      date: "2025-07-03",
    },
    {
      id: 3,
      name: "Michael Johnson",
      image: "/static/images/placeholder.png",
      email: "michael@example.com",
      membership: "Single",
      date: "2025-07-05",
    },
    {
      id: 4,
      name: "Emily Davis",
      image: "/static/images/placeholder.png",
      email: "emily@example.com",
      membership: "Duo",
      date: "2025-07-07",
    },
  ];
  return (
    <>
      <MainContainer>
        <div className="main_title">
          <h1 className="back_arrow">
            {" "}
            <IconButton onClick={() => goBack()}>
              {" "}
              <ArrowBackIcon />{" "}
            </IconButton>{" "}
            View Subscription
          </h1>
        </div>

        <div className="cards view_page">
          <div className="section_sub_title mb_30">
            <figure>
              <img alt="user" src="/static/images/duo_icon.svg" />
            </figure>{" "}
            <h3>Duo Membership</h3>
          </div>

          <div className="gap_p ">
            <div className="w_25">
              <h6>Payment Method:</h6>
              <p>Monthly</p>
            </div>
            <div className="w_25">
              <h6>Created Date</h6>
              <p>18 - June - 2025</p>
            </div>
            <div className="w_25">
              <h6>Price</h6>
              <p>AED 4,500</p>
            </div>
            <div className="w_100">
              <h6>Description</h6>
              <p>
                Lorem ipsum dolor sit amet consectetur, adipisicing elit.
                Tempora corrupti veritatis quia nulla suscipit, maiores ipsam
                perspiciatis officia laboriosam natus!
              </p>
            </div>
          </div>
        </div>
        <div className="cards view_page">
          <div className="section_sub_title mb_30">
            <h3>Subscription History</h3>
          </div>
          <div className="table_container">
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th>User Details</th>
                  <th>Email</th>
                  
                  <th>Subscription Date</th>
                </tr>
              </thead>
              <tbody>
                {subscriptionData.map((user) => (
                  <tr key={user.id}>
                    <td
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <img
                        src={user.image}
                        alt={user.name}
                        style={{
                          width: "40px",
                          height: "40px",
                          borderRadius: "50%",
                          objectFit: "cover",
                        }}
                      />
                      {user.name}
                    </td>
                    <td>{user.email}</td>
                
                    <td>{user.date}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </MainContainer>
    </>
  );
};

export default ViewSubscription;
